import { tracking } from '@iwoca/frontend-tracking-library';

import { TrackingSource } from '../BankSelectionModal/trackingSource';

export type ShareableLinkStep = 'entry' | 'explainer' | 'consent' | 'link';

// Not exported: knip fails CI on exports no other file imports.
type GenerateOutcome = 'generated' | 'failed';

const UNKNOWN_FAILURE_REASON = 'unknown';

export const getFailureReason = (error: unknown) =>
    error instanceof Error && error.message
        ? error.message
        : UNKNOWN_FAILURE_REASON;

export const trackStepViewed = ({
    step,
    source,
    connectionCount
}: {
    step: ShareableLinkStep;
    source: TrackingSource;
    connectionCount: number;
}) =>
    tracking.ampli.openBankingShareableLinkStepViewed({
        step,
        source,
        connection_count: connectionCount
    });

export const trackGenerateOutcome = ({
    outcome,
    failureReason,
    hadConsent,
    source,
    connectionCount
}: {
    outcome: GenerateOutcome;
    failureReason?: string;
    hadConsent: boolean;
    source: TrackingSource;
    connectionCount: number;
}) =>
    tracking.ampli.openBankingShareableLinkGenerateOutcome({
        ob_share_link_outcome: outcome,
        ...(failureReason && {
            ob_share_link_failure_reason: failureReason
        }),
        had_consent: hadConsent,
        source,
        connection_count: connectionCount
    });

// The link is a 90 day bearer credential, so it must never be sent to Amplitude.
export const trackCopied = (source: TrackingSource) =>
    tracking.ampli.openBankingShareableLinkCopied({ source });
